<template>
  <div class="home">
    <RequestPage />
      <div v-if="loading && !showModal" class="loader-container">
        <img
          v-show="loading"
          class="loader"
          src="@/assets/images/global/loader.gif"
          alt=""
        />
      </div>

    <div id="requestKitsModal" v-if="showModal">
      <h2>Sun Hero HQ Alert!</h2>
      <p>We are currently fresh out of kits but don’t worry, we’re restocking our super supplies.</p>
      <p>Check back soon to place your order!</p>
      <p><button @click="goBackHome">
        CLOSE <span><i class="fas fa-times"></i></span>
      </button></p>
    </div>
    <div class="overlay" v-if="showModal"></div>
  </div>
</template>

<script>
import RequestPage from '../components/elements/pages/RequestPage.vue'
export default {
  name: 'Request',
  metaInfo: {
    title: 'Request Kits'
  },
  components: {
    RequestPage
  },
  data () {
    return {
      showModal: false,
      loading: false
    }
  },
  created () {
    this.getInitial()
  },
  mounted () {
    // this.showModal = true
  },
  methods: {
    goBackHome () {
      this.showModal = false
      this.$router.push({ name: 'HomeLoggedIn' })
    },

    getInitial () {
      this.loading = true
      this.axios
        .get(this.$apiUrl + 'v1/admin/options/get/global_disable_ordering')
        .then((response) => {
          if (response.data) {
            this.showModal = response.data === 1
          }
          this.loading = false
        })
        .catch(() => {
          this.showModal = true
          this.loading = false
        })
    }
  }

}
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";
section.home-hero {
  background-size: 100% 100%;
  padding: 0;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
  }
}
#requestKitsModal {
  position: fixed;
  text-align: center;
  top: 200px;
  width: 80%;
  max-width: 95%;
  max-height: 95%;
  left: 50%;
  margin-left: -40%;
  padding: 30px 30px 60px 30px;
  z-index: 1000;
  border-radius: 10px;
  background-color: white;
  box-shadow: #110f2e 0 0 10px;
  @media screen and (max-width: 768px) {
    width: 90%;
    top: 50px;
    margin-left: -45%;
  }
  transition: all 0.3s ease;
  h2 {
    margin-bottom: 2em;
  }
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 999;
  transition: all 0.3s ease;
}
.loader-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  z-index: 999;
}
.loader {
  height: 50px;
  width: 50px;
  margin-top: 35%;
}
</style>
